import React from 'react';

const customReactionOptions = [
    {
        Component: () => React.createElement(React.Fragment, null, "\u2764\uFE0F"),
        name: "Love",
        type: "heart",
    },
    {
        Component: () => React.createElement(React.Fragment, null, "\uD83D\uDE4F"),
        name: "Pray",
        type: "pray",
    },
    {
        Component: () => React.createElement(React.Fragment, null, "\uD83D\uDE02"),
        name: "Laughing",
        type: "laughing",
    },
    {
        Component: () => React.createElement(React.Fragment, null, "\uD83D\uDC4D"),
        name: "Thumbs up",
        type: "+1",
    },
    {
        Component: () => React.createElement(React.Fragment, null, "\uD83D\uDC4E"),
        name: "Thumbs down",
        type: "-1",
    },
];

export { customReactionOptions };
//# sourceMappingURL=custom_reaction_options.js.map
